const EMAIL_REGEXP = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
const DATE_REGEXP = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
const MX_CURP_REGEXP = '';
const MX_RFC_COMPANY_REGEXP = '';
const MX_RFC_INDIVIDUAL_REGEXP = '';
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*-_#^()=+<>?&])[A-Za-z\d@$!%*-_#^()=+<>?&]{8,}$/;
const PHONE_NUMBER_REGEXP = /^[0-9]{10}$/;
const URL_REGEXP = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;

export {
  EMAIL_REGEXP,
  DATE_REGEXP,
  MX_CURP_REGEXP,
  MX_RFC_COMPANY_REGEXP,
  MX_RFC_INDIVIDUAL_REGEXP,
  PASSWORD_REGEX,
  PHONE_NUMBER_REGEXP,
  URL_REGEXP,
};
